<nb-card>
  <nb-card-header>
    <div class="form-inline">
      <ngx-view-time-period
        (periodChange)="selectTime($event)"
        [typeSelected]="'today'"
      ></ngx-view-time-period>

      <button
        nbButton
        hero
        shape="semi-round"
        status="primary"
        size="small"
        outline
        (click)="onNew()"
      >
        <nb-icon icon="file-add-outline"></nb-icon>
        Tạo mới
      </button>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="table-responsive">
      <ng2-smart-table
        [settings]="settings"
        [source]="source"
        (userRowSelect)="selectedItem($event)"
      >
      </ng2-smart-table>
      <strong class="text-hint">Tổng số: {{ source.count() }}</strong>
    </div>
  </nb-card-body>

  <nb-card-footer> </nb-card-footer>
</nb-card>
